import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_PATH,
  headers: {
    // Authorization: `Basic ${process.env.REACT_APP_API_BASIC_TOKEN}`,
  },
});

export const setAuthorizationHeader = (authorizationToken: string) => {
  api.defaults.headers.common['Authorization'] = `Bearer ${authorizationToken}`;
};

export const waitForAuthorizationHeader = (maxWaitTime = 3000, checkInterval = 100): Promise<void> => {
  return new Promise((resolve) => {
    const startTime = Date.now();

    const checkHeader = () => {
      const authHeader = api.defaults.headers.common['Authorization'];

      if (authHeader) {
        resolve();
        return;
      }

      if (Date.now() - startTime >= maxWaitTime) {
        resolve();
        return;
      }

      setTimeout(checkHeader, checkInterval);
    };

    checkHeader();
  });
};
